import React, { Component } from 'react';
import styles from './index.css';

export default class Drop extends Component {
    render() {
        return (
            <div className={styles.drop + (this.props.className ? ' ' + this.props.className : '')}
                 style={this.props.style ? {...this.props.style, opacity:'0'} : {opacity:'0'}}
                 data-droptype={this.props.type}
                 id={this.props.id}
                 onClick={(e)=>{e.preventDefault();this.props.onDrop()}}
            >
                <div className={styles.fields}>{this.props.children}</div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/shared/components/DragNDrop/Drop/index.js